__turbopack_context__.v({
  "className": "carmatitlefont_a200172c-module__aESV6a__className",
  "variable": "carmatitlefont_a200172c-module__aESV6a__variable",
});
